import "./AddComicModal.scss";

import AddComicModal from "./AddComicModal";

export default AddComicModal;
